import { SearchResponse, PokemonCard } from '../types';

const BASE_URL = 'https://api.pokemontcg.io/v2';
const POKEMON_API_KEY = 'ba4191ba-d7a6-4de7-91fb-d0fa96b9d0d0';

// Simple in-memory cache
const requestCache = new Map<string, SearchResponse>();

// API Status tracking
let isApiHealthy = true;
let lastApiCheck = 0;
const API_CHECK_INTERVAL = 60000; // Check every minute

// Enhanced Fallback Data - More cards for better search experience
export const FALLBACK_TICKER_CARDS: Partial<PokemonCard>[] = [
  {
    id: 'sv8-162',
    name: 'Victini ex',
    supertype: 'Pokémon',
    subtypes: ['Basic', 'ex'],
    rarity: 'Special Illustration Rare',
    number: '162',
    artist: 'Saya Tsuruta',
    set: {
      id: 'sv8',
      name: 'Surging Sparks',
      series: 'Scarlet & Violet',
      printedTotal: 191,
      total: 252,
      releaseDate: '2024/11/08',
      images: { symbol: 'https://images.pokemontcg.io/sv8/symbol.png', logo: 'https://images.pokemontcg.io/sv8/logo.png' }
    },
    images: { small: 'https://images.pokemontcg.io/sv8/162.png', large: 'https://images.pokemontcg.io/sv8/162_hires.png' },
    tcgplayer: { prices: { holofoil: { market: 391.43 } } } as any
  },
  {
    id: 'sv8-163',
    name: 'Zekrom ex',
    supertype: 'Pokémon',
    subtypes: ['Basic', 'ex'],
    rarity: 'Special Illustration Rare',
    number: '163',
    artist: 'Takumi Wada',
    set: {
      id: 'sv8',
      name: 'Surging Sparks',
      series: 'Scarlet & Violet',
      printedTotal: 191,
      total: 252,
      releaseDate: '2024/11/08',
      images: { symbol: 'https://images.pokemontcg.io/sv8/symbol.png', logo: 'https://images.pokemontcg.io/sv8/logo.png' }
    } as any,
    images: { small: 'https://images.pokemontcg.io/sv8/163.png', large: 'https://images.pokemontcg.io/sv8/163_hires.png' },
    tcgplayer: { prices: { holofoil: { market: 368.16 } } } as any
  },
  {
    id: 'sv7-203',
    name: 'Dragonite ex',
    supertype: 'Pokémon',
    subtypes: ['Stage 2', 'ex'],
    rarity: 'Special Illustration Rare',
    number: '203',
    artist: 'Jerky',
    set: {
      id: 'sv7',
      name: 'Stellar Crown',
      series: 'Scarlet & Violet',
      printedTotal: 142,
      total: 175,
      releaseDate: '2024/09/13',
      images: { symbol: 'https://images.pokemontcg.io/sv7/symbol.png', logo: 'https://images.pokemontcg.io/sv7/logo.png' }
    } as any,
    images: { small: 'https://images.pokemontcg.io/sv7/203.png', large: 'https://images.pokemontcg.io/sv7/203_hires.png' },
    tcgplayer: { prices: { holofoil: { market: 285.00 } } } as any
  },
  {
    id: 'sv6-201',
    name: 'Gengar ex',
    supertype: 'Pokémon',
    subtypes: ['Stage 2', 'ex'],
    rarity: 'Special Illustration Rare',
    number: '201',
    artist: 'Sowsow',
    set: {
      id: 'sv6',
      name: 'Twilight Masquerade',
      series: 'Scarlet & Violet',
      printedTotal: 167,
      total: 226,
      releaseDate: '2024/05/24',
      images: { symbol: 'https://images.pokemontcg.io/sv6/symbol.png', logo: 'https://images.pokemontcg.io/sv6/logo.png' }
    } as any,
    images: { small: 'https://images.pokemontcg.io/sv6/201.png', large: 'https://images.pokemontcg.io/sv6/201_hires.png' },
    tcgplayer: { prices: { holofoil: { market: 175.00 } } } as any
  },
  {
    id: 'sv4-227',
    name: 'Charizard ex',
    supertype: 'Pokémon',
    subtypes: ['Stage 2', 'ex'],
    rarity: 'Special Illustration Rare',
    number: '227',
    artist: 'AKIRA EGAWA',
    set: {
      id: 'sv4',
      name: 'Paradox Rift',
      series: 'Scarlet & Violet',
      printedTotal: 182,
      total: 266,
      releaseDate: '2023/11/03',
      images: { symbol: 'https://images.pokemontcg.io/sv4/symbol.png', logo: 'https://images.pokemontcg.io/sv4/logo.png' }
    } as any,
    images: { small: 'https://images.pokemontcg.io/sv4/227.png', large: 'https://images.pokemontcg.io/sv4/227_hires.png' },
    tcgplayer: { prices: { holofoil: { market: 325.00 } } } as any
  },
  {
    id: 'base1-4',
    name: 'Charizard',
    supertype: 'Pokémon',
    subtypes: ['Stage 2'],
    hp: '120',
    types: ['Fire'],
    rarity: 'Rare Holo',
    number: '4',
    artist: 'Mitsuhiro Arita',
    set: {
      id: 'base1',
      name: 'Base Set',
      series: 'Base',
      printedTotal: 102,
      total: 102,
      releaseDate: '1999/01/09',
      images: { symbol: 'https://images.pokemontcg.io/base1/symbol.png', logo: 'https://images.pokemontcg.io/base1/logo.png' }
    } as any,
    images: { small: 'https://images.pokemontcg.io/base1/4.png', large: 'https://images.pokemontcg.io/base1/4_hires.png' },
    tcgplayer: { prices: { holofoil: { market: 350.00 } } } as any
  },
  {
    id: 'base1-58',
    name: 'Pikachu',
    supertype: 'Pokémon',
    subtypes: ['Basic'],
    hp: '40',
    types: ['Lightning'],
    rarity: 'Common',
    number: '58',
    artist: 'Mitsuhiro Arita',
    set: {
      id: 'base1',
      name: 'Base Set',
      series: 'Base',
      printedTotal: 102,
      total: 102,
      releaseDate: '1999/01/09',
      images: { symbol: 'https://images.pokemontcg.io/base1/symbol.png', logo: 'https://images.pokemontcg.io/base1/logo.png' }
    } as any,
    images: { small: 'https://images.pokemontcg.io/base1/58.png', large: 'https://images.pokemontcg.io/base1/58_hires.png' },
    tcgplayer: { prices: { normal: { market: 15.00 } } } as any
  },
  {
    id: 'base1-2',
    name: 'Blastoise',
    supertype: 'Pokémon',
    subtypes: ['Stage 2'],
    hp: '100',
    types: ['Water'],
    rarity: 'Rare Holo',
    number: '2',
    artist: 'Ken Sugimori',
    set: {
      id: 'base1',
      name: 'Base Set',
      series: 'Base',
      printedTotal: 102,
      total: 102,
      releaseDate: '1999/01/09',
      images: { symbol: 'https://images.pokemontcg.io/base1/symbol.png', logo: 'https://images.pokemontcg.io/base1/logo.png' }
    } as any,
    images: { small: 'https://images.pokemontcg.io/base1/2.png', large: 'https://images.pokemontcg.io/base1/2_hires.png' },
    tcgplayer: { prices: { holofoil: { market: 120.00 } } } as any
  },
  {
    id: 'base1-1',
    name: 'Alakazam',
    supertype: 'Pokémon',
    subtypes: ['Stage 2'],
    hp: '80',
    types: ['Psychic'],
    rarity: 'Rare Holo',
    number: '1',
    artist: 'Ken Sugimori',
    set: {
      id: 'base1',
      name: 'Base Set',
      series: 'Base',
      printedTotal: 102,
      total: 102,
      releaseDate: '1999/01/09',
      images: { symbol: 'https://images.pokemontcg.io/base1/symbol.png', logo: 'https://images.pokemontcg.io/base1/logo.png' }
    } as any,
    images: { small: 'https://images.pokemontcg.io/base1/1.png', large: 'https://images.pokemontcg.io/base1/1_hires.png' },
    tcgplayer: { prices: { holofoil: { market: 85.00 } } } as any
  },
  {
    id: 'swsh9-18',
    name: 'Mew VMAX',
    supertype: 'Pokémon',
    subtypes: ['VMAX'],
    hp: '310',
    types: ['Psychic'],
    rarity: 'Rare Holo VMAX',
    number: '114',
    artist: '5ban Graphics',
    set: {
      id: 'swsh9',
      name: 'Brilliant Stars',
      series: 'Sword & Shield',
      printedTotal: 172,
      total: 172,
      releaseDate: '2022/02/25',
      images: { symbol: 'https://images.pokemontcg.io/swsh9/symbol.png', logo: 'https://images.pokemontcg.io/swsh9/logo.png' }
    } as any,
    images: { small: 'https://images.pokemontcg.io/swsh9/114.png', large: 'https://images.pokemontcg.io/swsh9/114_hires.png' },
    tcgplayer: { prices: { holofoil: { market: 45.00 } } } as any
  },
  {
    id: 'swsh10-46',
    name: 'Arceus VSTAR',
    supertype: 'Pokémon',
    subtypes: ['VSTAR'],
    hp: '280',
    types: ['Colorless'],
    rarity: 'Rare Holo VSTAR',
    number: '123',
    artist: '5ban Graphics',
    set: {
      id: 'swsh10',
      name: 'Astral Radiance',
      series: 'Sword & Shield',
      printedTotal: 189,
      total: 189,
      releaseDate: '2022/05/27',
      images: { symbol: 'https://images.pokemontcg.io/swsh10/symbol.png', logo: 'https://images.pokemontcg.io/swsh10/logo.png' }
    } as any,
    images: { small: 'https://images.pokemontcg.io/swsh10/123.png', large: 'https://images.pokemontcg.io/swsh10/123_hires.png' },
    tcgplayer: { prices: { holofoil: { market: 65.00 } } } as any
  },
  {
    id: 'swsh12-155',
    name: 'Lugia VSTAR',
    supertype: 'Pokémon',
    subtypes: ['VSTAR'],
    hp: '280',
    types: ['Colorless'],
    rarity: 'Rare Holo VSTAR',
    number: '139',
    artist: '5ban Graphics',
    set: {
      id: 'swsh12',
      name: 'Silver Tempest',
      series: 'Sword & Shield',
      printedTotal: 196,
      total: 196,
      releaseDate: '2022/11/11',
      images: { symbol: 'https://images.pokemontcg.io/swsh12/symbol.png', logo: 'https://images.pokemontcg.io/swsh12/logo.png' }
    } as any,
    images: { small: 'https://images.pokemontcg.io/swsh12/139.png', large: 'https://images.pokemontcg.io/swsh12/139_hires.png' },
    tcgplayer: { prices: { holofoil: { market: 125.00 } } } as any
  },
  {
    id: 'sm75-3',
    name: 'Zoroark GX',
    supertype: 'Pokémon',
    subtypes: ['Stage 1', 'GX'],
    hp: '210',
    types: ['Darkness'],
    rarity: 'Rare Holo GX',
    number: '53',
    artist: '5ban Graphics',
    set: {
      id: 'sm75',
      name: 'Hidden Fates',
      series: 'Sun & Moon',
      printedTotal: 68,
      total: 68,
      releaseDate: '2019/08/23',
      images: { symbol: 'https://images.pokemontcg.io/sm75/symbol.png', logo: 'https://images.pokemontcg.io/sm75/logo.png' }
    } as any,
    images: { small: 'https://images.pokemontcg.io/sm75/53.png', large: 'https://images.pokemontcg.io/sm75/53_hires.png' },
    tcgplayer: { prices: { holofoil: { market: 35.00 } } } as any
  },
  {
    id: 'xy12-12',
    name: 'M Charizard EX',
    supertype: 'Pokémon',
    subtypes: ['MEGA'],
    hp: '230',
    types: ['Fire'],
    rarity: 'Rare Holo EX',
    number: '12',
    artist: '5ban Graphics',
    set: {
      id: 'xy12',
      name: 'Evolutions',
      series: 'XY',
      printedTotal: 108,
      total: 108,
      releaseDate: '2016/11/02',
      images: { symbol: 'https://images.pokemontcg.io/xy12/symbol.png', logo: 'https://images.pokemontcg.io/xy12/logo.png' }
    } as any,
    images: { small: 'https://images.pokemontcg.io/xy12/12.png', large: 'https://images.pokemontcg.io/xy12/12_hires.png' },
    tcgplayer: { prices: { holofoil: { market: 55.00 } } } as any
  },
  {
    id: 'bw11-15',
    name: 'Rayquaza EX',
    supertype: 'Pokémon',
    subtypes: ['Basic', 'EX'],
    hp: '170',
    types: ['Dragon'],
    rarity: 'Rare Holo EX',
    number: '75',
    artist: 'Ryo Ueda',
    set: {
      id: 'bw11',
      name: 'Legendary Treasures',
      series: 'Black & White',
      printedTotal: 113,
      total: 113,
      releaseDate: '2013/11/06',
      images: { symbol: 'https://images.pokemontcg.io/bw11/symbol.png', logo: 'https://images.pokemontcg.io/bw11/logo.png' }
    } as any,
    images: { small: 'https://images.pokemontcg.io/bw11/75.png', large: 'https://images.pokemontcg.io/bw11/75_hires.png' },
    tcgplayer: { prices: { holofoil: { market: 95.00 } } } as any
  },
  {
    id: 'pl1-1',
    name: 'Dialga G',
    supertype: 'Pokémon',
    subtypes: ['Basic', 'G'],
    hp: '100',
    types: ['Metal'],
    rarity: 'Rare Holo',
    number: '7',
    artist: 'Makoto Imai',
    set: {
      id: 'pl1',
      name: 'Platinum',
      series: 'Platinum',
      printedTotal: 127,
      total: 127,
      releaseDate: '2009/02/11',
      images: { symbol: 'https://images.pokemontcg.io/pl1/symbol.png', logo: 'https://images.pokemontcg.io/pl1/logo.png' }
    } as any,
    images: { small: 'https://images.pokemontcg.io/pl1/7.png', large: 'https://images.pokemontcg.io/pl1/7_hires.png' },
    tcgplayer: { prices: { holofoil: { market: 25.00 } } } as any
  }
];

// Extended Fallback Data for Search - includes search functionality within fallback
const _FALLBACK_SEARCH_RESULTS: SearchResponse = {
  data: FALLBACK_TICKER_CARDS as PokemonCard[],
  page: 1,
  pageSize: 20,
  count: FALLBACK_TICKER_CARDS.length,
  totalCount: FALLBACK_TICKER_CARDS.length
};

// Search within fallback data
function searchFallbackData(query: string): SearchResponse {
  const q = query.toLowerCase().trim();

  if (!q || q === 'set.series:"scarlet & violet"') {
    // Return default set (Scarlet & Violet cards)
    const svCards = FALLBACK_TICKER_CARDS.filter((card: any) =>
      card.set?.series === 'Scarlet & Violet'
    );
    return {
      data: svCards as PokemonCard[],
      page: 1,
      pageSize: 20,
      count: svCards.length,
      totalCount: svCards.length
    };
  }

  // Search by name, set, or series
  const results = FALLBACK_TICKER_CARDS.filter((card: any) => {
    const nameMatch = card.name?.toLowerCase().includes(q);
    const setMatch = card.set?.name?.toLowerCase().includes(q);
    const seriesMatch = card.set?.series?.toLowerCase().includes(q);
    const typeMatch = card.types?.some((t: string) => t.toLowerCase().includes(q));
    return nameMatch || setMatch || seriesMatch || typeMatch;
  });

  return {
    data: results as PokemonCard[],
    page: 1,
    pageSize: 20,
    count: results.length,
    totalCount: results.length
  };
}

// Retry Helper for Mobile Stability
async function fetchWithRetry(url: string, options: RequestInit, retries = 3, backoff = 300): Promise<Response> {
  try {
    const response = await fetch(url, options);
    if (!response.ok && response.status === 429) {
      throw new Error('Rate Limited');
    }
    return response;
  } catch (err) {
    if (retries > 0) {
      await new Promise(resolve => setTimeout(resolve, backoff));
      return fetchWithRetry(url, options, retries - 1, backoff * 2);
    }
    throw err;
  }
}

// Check API health
async function _checkApiHealth(): Promise<boolean> {
  const now = Date.now();
  if (now - lastApiCheck < API_CHECK_INTERVAL) {
    return isApiHealthy;
  }

  try {
    const response = await fetch(`${BASE_URL}/cards?page=1&pageSize=1`, {
      method: 'HEAD',
      headers: { 'X-Api-Key': POKEMON_API_KEY }
    });
    isApiHealthy = response.ok;
    lastApiCheck = now;
    return isApiHealthy;
  } catch {
    isApiHealthy = false;
    lastApiCheck = now;
    return false;
  }
}

export const pokemonService = {
  /**
   * Searches for cards. If API is down, uses fallback data with search capability.
   */
  async searchCards(query: string = '', page: number = 1, pageSize: number = 20): Promise<SearchResponse> {
    const cacheKey = `${query.trim()}_${page}`;

    // Return cached response if available
    if (requestCache.has(cacheKey)) {
      return requestCache.get(cacheKey)!;
    }

    // Quick health check - if API was recently down, skip trying
    if (!isApiHealthy && Date.now() - lastApiCheck < API_CHECK_INTERVAL) {
      console.warn('Pokemon TCG API is known to be down, using fallback data immediately');
      const fallback = searchFallbackData(query);
      requestCache.set(cacheKey, fallback);
      return fallback;
    }

    let q = query.trim();

    if (!q) {
      q = 'set.series:"Scarlet & Violet"';
    } else {
      if (!q.includes(':')) {
        const sanitized = q.replace(/"/g, '\\"');
        q = `(name:"${sanitized}*" OR set.name:"${sanitized}*" OR set.series:"${sanitized}*")`;
      }
    }

    try {
      const url = `${BASE_URL}/cards?q=${encodeURIComponent(q)}&page=${page}&pageSize=${pageSize}&orderBy=-set.releaseDate,name`;

      const response = await fetchWithRetry(url, {
        method: 'GET',
        headers: {
          'X-Api-Key': POKEMON_API_KEY,
          'Accept': 'application/json'
        }
      });

      if (!response.ok) {
        console.warn(`Card Search API returned ${response.status}. Using enhanced fallback.`);
        isApiHealthy = false;
        lastApiCheck = Date.now();
        const fallback = searchFallbackData(query);
        requestCache.set(cacheKey, fallback);
        return fallback;
      }

      const result = await response.json();
      isApiHealthy = true;
      lastApiCheck = Date.now();

      // Cache the successful result
      requestCache.set(cacheKey, result);

      return result;
    } catch (err) {
      console.error('Pokemon TCG API Error:', err);
      isApiHealthy = false;
      lastApiCheck = Date.now();

      // Use enhanced fallback with search
      const fallback = searchFallbackData(query);
      requestCache.set(cacheKey, fallback);
      return fallback;
    }
  },

  /**
   * Fetches high-value cards for the ticker.
   */
  async getTrendingHighValueCards(): Promise<PokemonCard[]> {
    // If API is known down, return fallback immediately
    if (!isApiHealthy) {
      return FALLBACK_TICKER_CARDS as PokemonCard[];
    }

    try {
      const q = 'set.series:"Scarlet & Violet" (rarity:"Special Illustration Rare" OR rarity:"Hyper Rare")';
      const url = `${BASE_URL}/cards?q=${encodeURIComponent(q)}&page=1&pageSize=10&orderBy=-tcgplayer.prices.holofoil.market`;

      const response = await fetchWithRetry(url, {
        headers: { 'X-Api-Key': POKEMON_API_KEY }
      });

      if (!response.ok) throw new Error(`API Error: ${response.status}`);

      const json = await response.json();

      if (json.data && json.data.length > 0) {
        isApiHealthy = true;
        return json.data;
      }
      return FALLBACK_TICKER_CARDS as PokemonCard[];
    } catch {
      console.warn("Ticker API failed, using fallback");
      isApiHealthy = false;
      return FALLBACK_TICKER_CARDS as PokemonCard[];
    }
  },

  async getCardById(id: string): Promise<PokemonCard> {
    // Check fallback first if API is down
    if (!isApiHealthy) {
      const fallbackCard = FALLBACK_TICKER_CARDS.find(c => c.id === id);
      if (fallbackCard) return fallbackCard as PokemonCard;
      throw new Error('Card not found and API is unavailable.');
    }

    try {
      const response = await fetchWithRetry(`${BASE_URL}/cards/${id}`, {
        headers: {
          'X-Api-Key': POKEMON_API_KEY,
          'Accept': 'application/json'
        }
      });

      if (!response.ok) {
        const fallbackCard = FALLBACK_TICKER_CARDS.find(c => c.id === id);
        if (fallbackCard) return fallbackCard as PokemonCard;
        throw new Error('Card not found in the official archives.');
      }

      const json = await response.json();
      return json.data;
    } catch (err) {
      console.error('Fetch Card Error:', err);
      const fallbackCard = FALLBACK_TICKER_CARDS.find(c => c.id === id);
      if (fallbackCard) return fallbackCard as PokemonCard;
      throw err;
    }
  },

  /**
   * Check if the API is currently available
   */
  isApiAvailable(): boolean {
    return isApiHealthy;
  },

  /**
   * Get the full fallback card list
   */
  getFallbackCards(): PokemonCard[] {
    return FALLBACK_TICKER_CARDS as PokemonCard[];
  }
};
